import { ElasticSearchResponse, FilterPage, FilterPageDocument } from '@shared/services/elastic-search/models';

export const filterPagesSerializer = (filterPages: ElasticSearchResponse<FilterPageDocument>): FilterPage[] =>
  filterPages.hits.hits.map((filterPage) => {
    const source = filterPage._source;
    return {
      url: source.url?.[0] ?? '',
      title: source.title?.[0] ?? '',
      image: source.visuel?.[0] ?? null!,
    };
  });
